import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-assistant-trigger',
  standalone: true,
  imports: [FontAwesomeModule, TranslateModule],
  templateUrl: './assistant-trigger.component.html',
  styleUrls: ['./assistant-trigger.component.scss'],
})
export class AssistantTriggerComponent {
  @Input() labelKey = 'ASSISTANT.BUTTON_LABEL';
  @Input() titleKey = 'ASSISTANT.BUTTON_TITLE';
  @Input() disabled = false;
  @Output() triggered = new EventEmitter<void>();

  readonly icon = faWandMagicSparkles;
}
